import { useCallback } from 'react'
import { useProjektprognosInteractionContext } from '../context/ProjektprognosInteractionContext'

export const useHandleError = () => {
  const { setErrors } = useProjektprognosInteractionContext()

  const handleError = useCallback(
    (error: unknown) => {
      if (error instanceof Error) {
        setErrors((prevState) => [...prevState, error])
      } else {
        setErrors((prevState) => [
          ...prevState,
          new Error('Ett okänt fel uppstod'),
        ])
      }
    },
    [setErrors]
  )

  return handleError
}
